import { Injectable } from "@angular/core";
import {
  fetchCaselogs,
  setCaselogs,
  setFilters,
  setFiltersSuccess,
  setLoadingState,
} from "./dashboard.actions";
import { catchError, of, switchMap } from "rxjs";
import { CaseManagementService } from "src/app/pages/case-management/services/case-management.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "..";
import { HttpStatusCode } from "@angular/common/http";

@Injectable()
export class DashboardEffects {
  constructor(
    private actions$: Actions,
    private caseManagementService: CaseManagementService,
    private store: Store<AppState>
  ) {}

  fetchCaselogsOnFilterChange$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(setFilters),
      switchMap((action) => {
        return of(setFiltersSuccess({ filters: action.filters }));
      })
    );
  });

  fetchCaselogsEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchCaselogs),
      switchMap((action) => {
        this.store.dispatch(setLoadingState({ isLoading: true }));
        const filterString = this.caseManagementService.getFilters(action.filters);
        return this.caseManagementService.getCaseLogs(filterString).pipe(
          switchMap((data) => {
            const ok = data.status === HttpStatusCode.Ok;
            const caselogs = ok ? data?.data ?? [] : [];
            const pagination = ok ? data?.metaDataOptions?.pagination : null;
            const paginationMeta = {
              page: pagination?.page ?? 1,
              pageSize: pagination?.pageSize ?? this.caseManagementService.PAGE_SIZE,
              totalCount: pagination?.totalCount ?? 0,
              totalPages: pagination?.totalPages ?? 1,
            };
            return of(
              setCaselogs({ data: { caselogs, total: paginationMeta.totalCount, paginationMeta } }),
              setLoadingState({ isLoading: false })
            );
          }),

          catchError((error) => {
            console.error('[DashboardEffects] fetchCaselogsEffect$ failed:', error);
            return of(setLoadingState({ isLoading: false }));
          })
        );
      })
    );
  });
}
